<template>
    <div id="leader-main-container" class="page theme-dark">
        <Header
            :showTem="showTem"
            :isIndex="isIndex"
            :menuType="menuType"
            :title="title"
            :subTitle="subTitle"
            :showBack="showBack"
            :backType="backType"
            v-show="!noHeader"
            :class="[
                manyouType == null
                    ? ''
                    : manyouType == true
                        ? 'index_opa_n index-opacityN'
                        : 'index_opa_y index-opacityY'
            ]"
        ></Header>
        <div class="content-wrap">
            <div class="menuHideDiv" @mouseover="doShowMenu" v-show="showMenu"></div>
            <router-view></router-view>
        </div>
        <Bottom
            v-if="!touch && !noBottom"
            :menuType="menuType"
            :class="[
                manyouType == null
                    ? ''
                    : manyouType == true
                        ? 'index_opa_n index-opacityN'
                        : 'index_opa_y index-opacityY'
            ]"
            ref="footMenu"
        ></Bottom>
        <Menu
            v-if="!touch"
            :menuList="menuList"
            :showMenu.sync="showMenu"
            :openMenu.sync="openMenu"
            @changeTitle="changeTitle"
        ></Menu>
    </div>
</template>
<script>
import Header from "./components/leader-page-header";
import Bottom from "./components/leader-page-bottom";
import Menu from "./components/leader-page-menu";
import { svsMenu, analysisMenu } from "@/utils/menu-mock.js";
import Bus from "../system/comons/bus";
export default {
    name: "Main",
    components: {
        Header: Header,
        Bottom: Bottom,
        Menu: Menu
    },
    data() {
        return {
            menuType: null,
            showMenu: null,
            title: null,
            subTitle: "",
            winHeight: 0,
            showTem: false,
            showBack: false,
            backgroundColor: "",
            backType: "index",
            openMenu: false,
            menuTimer: null,
            noHeader: false,
            noBottom: true,
            isIndex: false,//用来指定首页，在leader-page-header里用到。目的是区分首页和其他页的title样式
            manyouType: null //3D漫游，true为漫游开始 ，false漫游结束
        };
    },
    computed: {
        touch() {
            return this.$store.state.index.touch;
        },
        menuList() {
            return this.$store.state.login.menuList;
        },
        userInfo() {
            return this.$store.state.login.userInfo;
        }
    },
    watch: {
        touch() {
            return this.$store.state.index.touch;
        },
        menuList() {
            return this.$store.state.login.menuList;
        },
        userInfo() {
            if (
                this.$store.state.login.userInfo &&
                this.$store.state.login.userInfo.user_type == "99"
            ) {
                this.setMenuTimer();
            }
            return this.$store.state.login.userInfo;
        }
    },
    methods: {
        doShowMenu() {
            this.openMenu = true;
        },
        changeTitle(router) {
            this.title=router.menu_name;
            sessionStorage.setItem('header-title',this.title);
        },
        setMenuTimer() {
            if (this.menuTimer) {
                clearInterval(this.menuTimer);
            }
            this.menuTimer = setInterval(() => {
                let activeSys = sessionStorage.getItem("activeSys");
                let sysCodeLength = this.$store.state.login.userInfo.sys_codes
                    .length;
                let activeSysIndex = (
                    this.$store.state.login.userInfo.sys_codes || []
                ).findIndex(sys_code => sys_code.sys_code == activeSys);
                if (activeSysIndex >= sysCodeLength - 1) {
                    // this.$refs.footMenu.changeSystem(
                    //     this.$store.state.login.userInfo.sys_codes[0]
                    // );
                    this.changeSystem(
                        this.$store.state.login.userInfo.sys_codes[0]
                    );
                } else {
                    this.changeSystem(
                        this.$store.state.login.userInfo.sys_codes[
                        activeSysIndex * 1 + 1
                        ]
                    );
                }
            }, 15000);
        },
        changeSystem(item) {
            let activeSys = item.sys_code;
            sessionStorage.setItem("activeSys", activeSys);
            sessionStorage.removeItem("activeTab");
            this.$store.commit("IS_CHANGE_SYSTEM", true);
            this.$store.dispatch("getMenuListByRoles", activeSys);
        }
    },
    created() {
        if (window.innerHeight) {
            this.winHeight =
                window.innerHeight > 900 ? window.innerHeight : 900;
        } else if (document.body && document.body.clientHeight) {
            this.winHeight =
                document.body.clientHeight > 900
                    ? document.body.clientHeight
                    : 900;
        }
        const path = this.$route.path;
    },
    mounted() {
        Bus.$on("toggleTopAndMenu", data => {
            this.manyouType = data;
        });
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.menuType = to.meta.menuType;
            if (to.name == "index" && to.query && to.query.touch) {
                vm.$store.commit("CHANGE_TOUCH", true);
            } else {
                vm.$store.dispatch("getUserInfo");
            }
            // 判断接线图是否显示右上角温湿度数据
            if (to.meta.showTem) {
                vm.showTem = true;
            }
            //是否有返回按钮
            if (to.meta.isBack) {
                vm.showBack = true;
            } else {
                vm.showBack = false;
            }
            // 判断头部返回按钮返回方式  back 回上一页  index 回首页
            if (to.meta.backType == "back") {
                vm.backType = "back";
            } else if (to.meta.backType == "index") {
                vm.backType = "index";
            }
            //判断是否显示菜单（没有菜单或者二级菜单长度为0都不显示菜单）
            setTimeout(() => {
                if (to.meta.noMenu || !vm.menuList.length) {
                    vm.showMenu = false;
                } else {
                    vm.showMenu = true;
                }
            }, 600);
            // vm.title = to.meta.title;
            vm.title = sessionStorage.getItem('header-title')?sessionStorage.getItem('header-title'):to.meta.title;
            vm.subTitle = to.meta.subTitle;
            vm.noHeader = to.meta.noHeader;
            vm.isIndex = to.meta.isIndex;
            if(to.meta.noBottom == undefined) vm.noBottom = true;
            else vm.noBottom = to.meta.noBottom;
            // sessionStorage.setItem("activeTab", to.name);
        });
    },
    beforeRouteUpdate(to, from, next) {
        if (to.name == "index" && to.query && to.query.touch) {
            this.$store.commit("CHANGE_TOUCH", true);
        }
        this.menuType = to.meta.menuType;
        // 判断接线图是否显示右上角温湿度数据
        if (to.meta.showTem) {
            this.showTem = true;
        }
        //判断是否显示菜单（没有菜单或者二级菜单长度为0都不显示菜单）
        if (to.meta.noMenu || !this.menuList.length) {
            this.showMenu = false;
        } else {
            this.showMenu = true;
        }
        //是否显示返回按钮
        if (to.meta.isBack) {
            this.showBack = true;
        } else {
            this.showBack = false;
        }
        // 判断头部返回按钮返回方式  back 回上一页  index 回首页
        if (to.meta.backType == "back") {
            this.backType = "back";
        } else if (to.meta.backType == "index") {
            this.backType = "index";
        }
        // this.title = to.meta.title;
        this.title = sessionStorage.getItem('header-title');
        // this.subTitle = to.meta.subTitle;
        this.noHeader = to.meta.noHeader;
        this.isIndex = to.meta.isIndex;
        if(to.meta.noBottom == undefined) this.noBottom = true;
        else this.noBottom = to.meta.noBottom;
        // sessionStorage.setItem("activeTab", to.name);
        next();
    },
    destroyed() {
        clearInterval(this.menuTimer);
    }
};
</script>
<style lang="scss">
@import "../../../assets/css/leaderpage.css";
.page {
    width: 100%;
    height: 100%;
    // min-height: 1080px;
    overflow: hidden;
    // background: url(../../../assets/image/index/bj.jpg) no-repeat;

    text-align: left;
    .content-wrap {
        width: 100%;
        height: calc(100% - #{px2Rem(45px)} - 5rem);

        .menuHideDiv {
            height: calc(100% - 12.5rem);
            width: 2px;
            background: transparent;
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 8;
          //  border: 1px solid red;
        }
    }

    .index_opa_y {
        opacity: 1;
    }
    .index_opa_n {
        opacity: 0;
    }
}
.index-opacityN {
    animation: index_opacity_n 2s;
}
@keyframes index_opacity_n {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.4;
    }
    100% {
        opacity: 0;
    }
}
@-webkit-keyframes index_opacity_n {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.4;
    }
    100% {
        opacity: 0;
    }
}
@-moz-keyframes index_opacity_n {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.4;
    }
    100% {
        opacity: 0;
    }
}
.index-opacityY {
    animation: index_opacity_y 2s;
}
@keyframes index_opacity_y {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0.4;
    }
    100% {
        opacity: 1;
    }
}
@-webkit-keyframes index_opacity_y {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0.4;
    }
    100% {
        opacity: 1;
    }
}
@-moz-keyframes index_opacity_y {
    0% {
        opacity: 0;
    }
    50% {
        opacity: 0.4;
    }
    100% {
        opacity: 1;
    }
}
</style>
